import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    h2{
        font-size: 32px;
        line-height: 40px;
        font-weight: 900;
        color: #000000;
    }
`;